import { lazy } from "react";
import Loadable from "../../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../../constants/enums";
const CertificateofInsuranceList = Loadable(
  lazy(() =>
    import("./CertificateofInsuranceList").then(
      ({ AutomobileCertificateOfInsuranceList }) => ({ default: AutomobileCertificateOfInsuranceList })
    )
  )
);

const AutomobileCSIOCertificat = Loadable(
  lazy(() =>
    import(
      "../../CSIOCertificate/CSIOCertificate"
    ).then(({ CSIOCertificate }) => ({
      default: CSIOCertificate,
    }))
  )
);
const AutomobileCertificateInsurance = Loadable(
  lazy(() =>
    import(
      "../../AutomobileCertificateInsurance/AutomobileCertificateInsurance"
    ).then(({ AutomobileCertificateInsurance }) => ({
      default: AutomobileCertificateInsurance,
    }))
  )
);

export const automobileCertificateOfInsuranceRouter = [
   {
         path: `/automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId`,
         exact: true,
         element: (
           <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
             <CertificateofInsuranceList />
           </AuthorizedRoute>
         ),
       },
    {
       path: `/automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/certificate-of-insurance`,
       exact: true,
       element: (
         <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
           <AutomobileCertificateInsurance />
         </AuthorizedRoute>
       ),
     },
     {
       path: `/automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/certificate-of-insurance/:serialNumber`,
       exact: true,
       element: (
         <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
           <AutomobileCertificateInsurance />
         </AuthorizedRoute>
       ),
     },
     {
       path: `/automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/certificate-of-insurance/duplicate/:serialNumber`,
       exact: true,
       element: (
         <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
           <AutomobileCertificateInsurance isDuplicate />
         </AuthorizedRoute>
       ),
     },
            {
                path: "/automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability-insurance",
                exact: true,
                element: (
                  <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                    <AutomobileCSIOCertificat />
                  </AuthorizedRoute>
                ),
              },
              {
                path: "/automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability-insurance/:serialNumber",
                exact: true,
                element: (
                  <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                    <AutomobileCSIOCertificat />
                  </AuthorizedRoute>
                ),
              },
              {
                path: "/automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability-insurance/duplicate/:serialNumber",
                exact: true,
                element: (
                  <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                    <AutomobileCSIOCertificat isDuplicate />
                  </AuthorizedRoute>
                ),
              },
]